export const cardBuilderActions = {
  CARD_ADDED: 'CARD_ADDED',
  CARD_REMOVED: 'CARD_REMOVED',
  CARD_SAVED: 'CARD_SAVED',
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  MODAL_CLOSED: 'MODAL_CLOSED',
};
